// themeConstants.js
export const FONT_FAMILY = "Work Sans, sans-serif";
export const FONT_FAMILY_ABRILA = "Abril Fatface, sans-serif";
